<div class="header">
  <img alt="logo" src="{{logoSrc}}" class="logo">
  <div class="right-column" (appOutsideClick)="outsideClick($event)">
    <app-searchbar class="header-searchbar" [showSearchBar]=false placeholder="{{ 'Search' | translate}}"
      (ionChange)="onSearch($event)" ngDefaultControl>
    </app-searchbar>
    <div *ngIf="isItemAvailable && suggestions.length > 0">
      <div class="list-view scrollVertical">
        <ion-item *ngFor="let item of suggestions" (click)="serachTerm(item.name)">
          <ion-spinner *ngIf="isLoading" class="loading-spinner"></ion-spinner>
          <ion-label>{{item.name}}</ion-label>
        </ion-item>
      </div>
    </div>
    <div class="language-dropdown-container">
      <div class="header-language-dropdown">
        <button
          #languageTrigger
          type="button"
          class="header-language-select"
          (click)="toggleLanguageDropdown()"
          (keydown)="onLanguageTriggerKeydown($event)"
          [attr.aria-expanded]="isLanguageDropdownOpen">
          <span class="header-language-value">{{ getSelectedLanguageLabel() }}</span>
          <ion-icon
            class="header-language-icon"
            name="chevron-down-outline"
            [class.open]="isLanguageDropdownOpen">
          </ion-icon>
        </button>

        <div class="header-language-panel" *ngIf="isLanguageDropdownOpen">
          <div
            #languageOption
            class="header-language-option"
            [class.selected]="selectedLanguage === language.code"
            [attr.tabindex]="i === 0 ? 0 : -1"
            [attr.role]="'option'"
            [attr.aria-selected]="selectedLanguage === language.code"
            *ngFor="let language of orderedLanguageOptions; let i = index"
            (keydown)="onLanguageOptionKeydown($event, i)"
            (click)="selectLanguage(language.code)">
            <span class="header-language-option-label">{{ language.label }} ({{ language.code }})</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ion-icon tabindex="0" role="button" class="notification-container" tooltip="{{'Notifications' | translate }}" placement="bottom" 
        name="notifications-outline" class="notification-icon" [ngClass]="{'margin-right-20': notificationUnreadCount === 0}"
        (click)="toggleNotificationPopup()"  (keydown.enter)="toggleNotificationPopup()"
        (keydown.space)="$event.preventDefault(); toggleNotificationPopup()">
      </ion-icon>
      <ion-badge *ngIf="notificationUnreadCount > 0"
        class="notification-badge">{{ notificationUnreadCount }}</ion-badge>
      <app-enhanced-notification (closeNotificationPopup)="closeNotificationPopup()" #enhancedNotification></app-enhanced-notification>
</div>  
    <div>
      <img id="header-profile-trigger" #profileTrigger (keydown.enter)="toggleUserProfilePopup($event)" tabindex="0"
     role="button" [src]="userInfo?.thumbnailUrl ? userInfo?.thumbnailUrl : '../../../assets/Profile_Potrait.svg'" alt="avatar" tooltip="{{'User profile' | translate}}" placement="bottom" class="profile"
      (keydown.space)="$event.preventDefault(); toggleUserProfilePopup($event)"
      (click)="toggleUserProfilePopup($event)">
    </div>
  </div>
</div>